import styled from '@emotion/styled';
import { InputAdornment, TextField } from '@goshippo/components';
import { ErrorMessage } from '~/components/Typography';
import * as React from 'react';
import { compose } from 'redux';
import { colors } from '~/styles/constants';
import { InjectedTranslateProps, translate } from '~/utils/translate';

const OuterContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const ColorPickerInputContainer = styled.div`
  position: relative;
  height: 3rem;
  width: 100%;
  text-align: center;
  color: ${colors.gray400};
  margin-right: 1.4375rem;
`;

const ErrorContainer = styled('div')`
  margin-top: 4px;
`;

interface ColorPickerInputProps {
  value: string;
  error?: string;
  hideErrorMessage?: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  disabled?: boolean;
}

const ColorPickerInput = ({
  t,
  value,
  error,
  hideErrorMessage,
  onChange,
  onBlur,
  disabled = false,
}: ColorPickerInputProps & InjectedTranslateProps) => {
  const handleTextInputFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    // Selects all text on focus
    e.target.select();
  };

  return (
    <OuterContainer>
      <ColorPickerInputContainer>
        <TextField
          error={!!error}
          label={t('branding.brandColor.inputLabel')}
          type="text"
          value={value}
          onChange={onChange}
          onFocus={handleTextInputFocus}
          onBlur={onBlur}
          disabled={disabled}
          inputProps={{
            maxLength: 6,
          }}
          InputProps={{
            startAdornment: <InputAdornment position="start">#</InputAdornment>,
          }}
        />
      </ColorPickerInputContainer>
      {error && !hideErrorMessage ? (
        <ErrorContainer>
          <ErrorMessage>{error}</ErrorMessage>
        </ErrorContainer>
      ) : null}
    </OuterContainer>
  );
};

const ComposedColorPickerInput = compose(translate('settings'))(ColorPickerInput);

export default ComposedColorPickerInput;
